import { Registry } from '@react-registry'

export const H5Deserializer = () => {
  return {
    type: 'h5'
  }
}

Registry.register(H5Deserializer, { id: 'H5', registry: 'v2.deserializer' })
